import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelatieStatusComponent } from './relatie-status.component';
import { AddRelatieStatusComponent } from './add-relatie-status/add-relatie-status.component';
import { EditRelatieStatusComponent } from './edit-relatie-status/edit-relatie-status.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        RelatieStatusComponent,
        AddRelatieStatusComponent,
        EditRelatieStatusComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [RelatieStatusComponent],
})
export class RelatieStatusModule { }
